export const SOURCE_TYPES = ["aws", "gcp", "sap"];
export const POLICY_NAME_MAX_LENGTH = 50;
export const POLICY_DESCRIPTION_MAX_LENGTH = 300;
export const POLICY_MAX_TAGS = 5;
export const ALPHA_NUM_REGEX = /^[a-zA-Z0-9 ,."-]+$/;
export const MAX_VISIBLE_OWNERS = 5;
export const CREATE_TICKET_MAX_SELECTION = 1000;
export const ASSIGN_OWNER_MAX_SELECTION = 100;
export const DEFAULT_FILTER_CHIPS_TO_SHOW = 5;
export const ACTION_DELETE = "DELETE";
export const ACTION_DISABLEACCOUNT = "DISABLEACCOUNT";
export const ACTION_CREATE = "CREATE";
export const ALL_FILTER_CHIPS = "all";
export const DEFAULT_ADD_OR_REMOVE_FILTER_CATEGORIES = ["Filter Group"];
export const DOWNLOAD_TIMEOUT = 60000; // 60 seconds for large files
export const NHI_TAB = "NHI_POSTURE";
export const AI_AGENT_TAB = "AI_POSTURE";
export const WORKFORCE_TAB = "WORKFORCE_POSTURE";
